import $ from "jquery";
import { dialogs } from "../components/dialogs";
import { modal } from "../components/modal";
import { displayErrors } from "./validation";
export const ajax = async ({ url, method, showModal, form, multipart, data, blockUi, }) => {
    let body;
    if (form) {
        body = multipart ? new FormData(form[0]) : new URLSearchParams(form.serialize());
    }
    else if (data) {
        body = new URLSearchParams($.param(data));
    }
    if (showModal || blockUi)
        dialogs.blockUi();
    const response = await fetch(url, {
        method: body ? "POST" : method,
        body,
        headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (showModal || blockUi)
        dialogs.unblockUi();
    let result = undefined;
    if (response.status === 200) {
        const contentType = response.headers.get("content-type");
        const responseIsJson = contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json");
        if (!responseIsJson && showModal) {
            const shownModal = modal.show(await response.text());
            return { success: true, modal: shownModal };
        }
        if (responseIsJson) {
            result = (await response.json());
            if (result.Success) {
                if (result.Reload) {
                    location.reload();
                    return new Promise(() => { });
                }
                if (result.RedirectUrl) {
                    location.href = result.RedirectUrl;
                    return new Promise(() => { });
                }
                if (result.Message)
                    dialogs.showDialog("alert", {
                        title: "Message",
                        message: result.Message,
                    });
                return { success: true, data: result.Data };
            }
            else {
                if (form) {
                    displayErrors(form, result);
                }
                else if (result.Message) {
                    dialogs.showDialog("alert", {
                        title: "Message",
                        message: result.Message,
                    });
                }
            }
        }
    }
    else {
        dialogs.showDialog("alert", {
            title: "Error",
            message: "An unexpected error occurred. Please try again.",
        });
    }
    return { success: false, data: result === null || result === void 0 ? void 0 : result.Data, message: result === null || result === void 0 ? void 0 : result.Message };
};
